import { defaultTo } from 'ramda';

import { IAppState } from '../../../../AppModulesWrapper';

import { EPlacingType, EServiceId, IPublicationTokens } from '../../../types/reducers/publishTerms';

import { selectPublicationPeriod } from '../selectPublicationPeriod';
import { selectActivePackage } from '../../../reducers/v2/publicationPackages/selectors/selectActivePackage';
import { selectActiveService } from '../selectActiveService';
import { selectActivePlacingType } from '../selectActivePlacingType';
import { selectIsPromotionPackageSelected } from '../selectIsPromotionPackageSelected';
import { selectIsDisabledPromotion } from '../selectIsDisabledPromotion';
import { selectIsServicesEnabled } from '../selectIsServicesEnabled';
import { selectTermsDurationInDays } from '../../termsDurations';
import { selectAuctionPeriod, selectCurrentBet, selectMinimalBet } from '../../auction';
import { selectIsIncreaseToMinimalTopBet } from '../selectIsIncreaseToMinimalTopBet';
import { selectActiveServiceId } from '../selectActiveServiceId';
import { selectActiveCalltrackingPeriod, selectIsCalltrackingEnabled } from '../../calltracking';

export const selectPublicationTokens = (state: IAppState): IPublicationTokens => {
  const publicationPeriod = defaultTo({ token: '' }, selectPublicationPeriod(state));
  const activePackage = defaultTo({ token: '' }, selectActivePackage(state));
  const activeService = selectActiveService(state);
  const placingType = selectActivePlacingType(state);
  const publicationToken = placingType === EPlacingType.balance ? publicationPeriod.token : activePackage.token;

  const publicationServicesTokens: IPublicationTokens = { publicationToken: defaultTo('', publicationToken) };

  const isCalltrackingEnabled = selectIsCalltrackingEnabled(state);
  const calltrackingPeriod = selectActiveCalltrackingPeriod(state);

  if (isCalltrackingEnabled && calltrackingPeriod?.token) {
    publicationServicesTokens.calltrackingToken = calltrackingPeriod.token;
  }

  const isPromotionPackageSelected = selectIsPromotionPackageSelected(state);
  const currentBet = selectCurrentBet(state);
  // Токен продвижения поставляется вместе со сроком продвижения
  // В будущем это поле будет удалено, так как для каждой услуги будет свой токен на каждый срок продвижения
  const promotionDurationInDays = selectTermsDurationInDays(state);
  const auctionPeriod = selectAuctionPeriod(state);

  if (isPromotionPackageSelected) {
    if (currentBet) {
      publicationServicesTokens.auctionBet = currentBet;
    }

    if (auctionPeriod?.token) {
      publicationServicesTokens.auctionToken = auctionPeriod?.token;
    }

    publicationServicesTokens.promotionDurationInDays = promotionDurationInDays;

    return publicationServicesTokens;
  }

  const isDisabledPromotionByReasons = selectIsDisabledPromotion(state);
  const isServicesEnabled = selectIsServicesEnabled(state);
  const disablePromotion = isDisabledPromotionByReasons ? true : !isServicesEnabled;

  if (disablePromotion || !activeService?.period?.token) {
    return publicationServicesTokens;
  }

  publicationServicesTokens.promotionToken = activeService.period.token;
  publicationServicesTokens.promotionDurationInDays = promotionDurationInDays;

  const minimalBet = selectMinimalBet(state);
  const increaseToMinimalTopBet = selectIsIncreaseToMinimalTopBet(state);
  const activeServiceId = selectActiveServiceId(state);
  const enableAuction = auctionPeriod?.token && (isPromotionPackageSelected || activeServiceId === EServiceId.top);

  if (enableAuction) {
    publicationServicesTokens.auctionToken = auctionPeriod.token as string;
    publicationServicesTokens.auctionBet = increaseToMinimalTopBet ? Math.max(currentBet, minimalBet) : currentBet;
  }

  return publicationServicesTokens;
};
